/* eslint-disable no-console */
import 'rxjs';
import { Observable } from 'rxjs/Observable';
import { ACCEPT_INVITATION } from '../actions';

const epic = (action$, store, { api }) =>
    action$.ofType(ACCEPT_INVITATION).mergeMap(action =>
        Observable.from(api.acceptInvitation(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .catch(() => Observable.of(errorAction())),
    );

const toAction = response =>
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    response ? console.log('Invitation accepted') : errorAction();

const errorAction = () => console.log('Invitation accept error');

export default epic;
